import React from 'react';

interface NinjaLogoProps {
  className?: string;
  size?: number | string;
}

export default function NinjaLogo({ className = "", size }: NinjaLogoProps) {
  const sizeStyles = size ? { width: size, height: size } : {};
  
  return (
    <div className={`text-primary ${className}`} style={sizeStyles}>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        className="w-full h-full"
      >
        {/* Round head */}
        <circle 
          cx="12" 
          cy="12" 
          r="8" 
          fill="currentColor"
        />
        
        {/* Cool sunglasses - continuous frame */}
        <path 
          d="M5 10h14" 
          stroke="black" 
          strokeWidth="1.2"
        />
        
        {/* Arms of sunglasses */}
        <path 
          d="M5 10L4 9M19 10L20 9" 
          stroke="black" 
          strokeWidth="1"
        />
        
        {/* Left lens - iconic shape */}
        <path
          d="M6 10L7 8.5h2.5L11 10v1L9.5 12.5h-2L6 11z"
          fill="black"
        />
        
        {/* Right lens - iconic shape */}
        <path
          d="M13 10L14 8.5h2.5L18 10v1L16.5 12.5h-2L13 11z"
          fill="black"
        />
      </svg>
    </div>
  );
} 